import { get, post, put } from './request';

export function create(json, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PLF_CATEGORY_CREATE'
    });

    post(`plf_category`, { json }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'PLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'PLF_CATEGORY_CREATE_OK', plfCategory: result.json });
        }
      }).catch(error => dispatch({ type: 'PLF_CATEGORY_CREATE_ERROR', error }));
  };
}

export function update(_id, json, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PLF_CATEGORY_UPDATE'
    });

    put(`plf_category/${_id}`, { json }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'PLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'PLF_CATEGORY_UPDATE_OK', plfCategory: result.json });
        }
      }).catch(error => dispatch({ type: 'PLF_CATEGORY_UPDATE_ERROR', error }));
  };
}

export function find(_id, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PLF_CATEGORY_GET'
    });

    get(`plf_category/${_id}`, { json: true }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'PLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'PLF_CATEGORY_GET_OK', plfCategory: result.json });
        }
      }).catch(error => dispatch({ type: 'PLF_CATEGORY_GET_ERROR', error }));
  };
}

export function all(kwargs = {}, callback = () => { }) {
  return (dispatch) => {
    dispatch({
      type: 'PLF_CATEGORIES_GET'
    });

    const q = kwargs.q ? `&q=${kwargs.q}` : '';
    const limit = `?limit=${kwargs.limit || 10}`;
    get(`plf_categories${limit}${q}`, { json: true }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'PLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'PLF_CATEGORIES_GET_OK', data: result.json });
        }
      }).catch(error => dispatch({ type: 'PLF_CATEGORIES_GET_ERROR', error }));
  };
}

